import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ProjectReviewApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'projectReviewInfo'
  }



}
